module.exports = __webpack_public_path__ + "d62c126cefdfc62006a3f94b8eb404ca.svg";